var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMyProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.3,
    transform: "translate(1.3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.26 19.917c.204 0 .4-.08.541-.225a.723.723 0 00.209-.537c-.413-4.748-4.472-8.399-9.345-8.404-4.896-.025-8.99 3.633-9.405 8.404-.008.2.067.393.209.537a.758.758 0 00.541.225h17.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.26 20.65H2.01c-.423 0-.826-.176-1.11-.483a1.446 1.446 0 01-.39-1.086c.464-5.12 4.838-9.053 10.095-9.078 5.285-.005 9.696 3.945 10.155 9.093.027.399-.114.79-.39 1.085a1.519 1.519 0 01-1.11.47zm-8.595-9.18c-4.482.013-8.215 3.364-8.61 7.729H19.26c-.411-4.373-4.164-7.718-8.655-7.715l.06-.015z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.605,
    cy: 6.967,
    fill: "#FFF",
    rx: 5.4,
    ry: 5.28
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.605 12.98c-3.397 0-6.15-2.692-6.15-6.013 0-1.595.648-3.125 1.801-4.252A6.223 6.223 0 0110.605.953c3.397 0 6.15 2.693 6.15 6.014 0 3.32-2.753 6.013-6.15 6.013zm0-10.56c-2.568 0-4.65 2.036-4.65 4.547 0 2.51 2.082 4.546 4.65 4.546 2.568 0 4.65-2.035 4.65-4.546s-2.082-4.547-4.65-4.547z"
  }))));
}
export default SvgIcMyProfile;